var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-stats"},[_c('h2',[_vm._v(_vm._s(_vm.comicStats.num_comics_siteWide)+" COMICS HAVE BEEN COLLECTED IN "+_vm._s(_vm.comicStats.num_collections_siteWide)+" COLLECTIONS! ")]),(_vm.$store.state.token === '')?_c('h4',[_vm._v("~~~ Register and make an account to start collecting today! ~~~")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }